export default __webpack_public_path__ + "static/media/knowledge-moderation.586e835a.md";